export default "__VITE_ASSET__y2qW61GP__"